import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import axios from 'axios';
  
const API_HOST_URL = process.env.REACT_APP_API_URL

  const LeavePolicyDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      state = {
        leaveTypes: [],
        days: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28, 'Last Day'],
        months: ['JANUARY', 'FEBUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'],
        periodTypes: ['DAYS', 'MONTHS'],
        accrualFrequencies: ['Daily','Weekly','Twice a month', 'Monthly', 'Twice a year', 'Quarterly', 'Yearly', 'Anniversary']
      }

      componentDidMount(){
        this.fetchLeaveTypes();
      }

      fetchLeaveTypes = () => {
        axios.get(`${API_HOST_URL}/api/leave/leavetype/`)
          .then(res => {
            this.setState({
              leaveTypes: res.data
            })
          })
      }

      handleSelectChange = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
          leaveType:  value
        });
    }

    handleSelectChange1 = (value) => {
      console.log(value);
      this.props.form.setFieldsValue({
        carryOverDay:  value
      });
  }

  handleSelectChange2 = (value) => {
    console.log(value);
    this.props.form.setFieldsValue({
      carryOverMonth:  value
    });
}

handleSelectChange3 = (value) => {
  console.log(value);
  this.props.form.setFieldsValue({
    afterHireStartPeriodType:  value
  });
}

handleSelectChange4 = (value) => {
  console.log(value);
  this.props.form.setFieldsValue({
    accrualFrequency:  value
  });
}

      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;
        const { Option } = Select;

        return (
          <Modal
            visible={visible}
            title="Add Leave Policy"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Leave Type">
                    {getFieldDecorator('leaveType', {
                      rules: [{ required: true, message: 'Please select leave type!' }],
                    })(
                      <Select
                        placeholder="Select Leave Type"
                        onChange={this.handleSelectChange}
                      >
                      {
                        this.state.leaveTypes.map(leaveType => 
                        <Option key={leaveType.id} value={ leaveType.id}>{ leaveType.leaveType }</Option>
                      )
                      }
                      </Select>
                    )}
              </Form.Item>
              <Form.Item label="Policy Name">
                {getFieldDecorator('policyName', {
                 initialValue: data.policyName,
                  rules: [{ required: true, message: 'Please input the Policy Name!' }],
                })( <Input /> )}
              </Form.Item>
              <Form.Item label="Carry Over Day">
                    {getFieldDecorator('carryOverDay', {
                      initialValue: data.carryOverDay,
                      rules: [{ required: true, message: 'Please select leave type!' }],
                    })(
                      <Select
                        placeholder="Select Day"
                        onChange={() => this.handleSelectChange1}
                      >
                      {
                        this.state.days.map(day => 
                        <Option key={ day } value={ day }>{ day }</Option>
                      )
                    }
                      </Select>
                    )}
              </Form.Item>
              <Form.Item label="Carry Over Month">
                    {getFieldDecorator('carryOverMonth', {
                      initialValue: data.carryOverMonth,
                      rules: [{ required: true, message: 'Please select Carry Over Month!' }],
                    })(
                      <Select
                        placeholder="Select Month"
                        onChange={this.handleSelectChange2}
                      >
                      {
                        this.state.months.map(month => 
                        <Option key={ month } value={ month }>{ month }</Option>
                      )
                    }
                      </Select>
                    )}
              </Form.Item>
              
              <Form.Item label="After Hire Start Period">
                {getFieldDecorator('afterHireStartPeriod', {
                 initialValue: data.afterHireStartPeriod,
                  rules: [{ required: true, message: 'Please input the After Hire Start Period!' }],
                })( <Input /> )}
              </Form.Item>
              <Form.Item label="After Hire Start Period Type">
                    {getFieldDecorator('afterHireStartPeriodType', {
                      initialValue: data.afterHireStartPeriodType,
                      rules: [{ required: true, message: 'Please select After Hire Start Period Type!' }],
                    })(
                      <Select
                        placeholder="Select Month"
                        onChange={this.handleSelectChange3}
                      >
                      {
                        this.state.periodTypes.map(periodType => 
                        <Option key={ periodType } value={ periodType }>{ periodType }</Option>
                      )
                    }
                      </Select>
                    )}
              </Form.Item>
              <Form.Item label="Accrual Leave Days">
                {getFieldDecorator('accrualAmount', {
                 initialValue: data.accrualAmount,
                  rules: [{ required: true, message: 'Please input the Accrual Amount!' }],
                })( <Input /> )}
              </Form.Item>
              <Form.Item label="Accrual Frequency">
                    {getFieldDecorator('accrualFrequency', {
                      initialValue: data.accrualFrequency,
                      rules: [{ required: true, message: 'Please select Accrual Frequency!' }],
                    })(
                      <Select
                        placeholder="Select Frequency"
                        onChange={this.handleSelectChange4}
                      >
                      {
                        this.state.accrualFrequencies.map(accrualFrequency => 
                        <Option key={ accrualFrequency } value={ accrualFrequency }>{ accrualFrequency }</Option>
                      )
                    }
                      </Select>
                    )}
              </Form.Item>
              <Form.Item label="Carry Over Leave Days">
                {getFieldDecorator('carryOverAmount', {
                 initialValue: data.carryOverAmount,
                  rules: [{ required: true, message: 'Please input the Carry Over Amount!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default LeavePolicyDialogForm;
